/** LIGHTBOX **/
document.querySelectorAll("[data-external-link]").forEach((link) => {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    const href = this.getAttribute("href");
    const lightbox = document.getElementById("lightbox");
    const iframe = document.getElementById("lightbox-iframe");
    iframe.src = href;
    lightbox.style.display = "flex";
  });
});

document
  .querySelector("#lightbox .close-btn")
  .addEventListener("click", function () {
    const lightbox = document.getElementById("lightbox");
    const iframe = document.getElementById("lightbox-iframe");
    iframe.src = "";
    lightbox.style.display = "none";
  });

/* Get Browser */
document.addEventListener("DOMContentLoaded", function () {
  let browser = "unknown";

  if (
    navigator.userAgent.indexOf("Chrome") !== -1 &&
    navigator.userAgent.indexOf("Edg") === -1
  ) {
    browser = "browser--chrome";
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    browser = "browser--firefox";
  } else if (
    navigator.userAgent.indexOf("Safari") !== -1 &&
    navigator.userAgent.indexOf("Chrome") === -1
  ) {
    browser = "browser--safari";
  } else if (navigator.userAgent.indexOf("Edg") !== -1) {
    browser = "browser--edge";
  } else if (
    navigator.userAgent.indexOf("Opera") !== -1 ||
    navigator.userAgent.indexOf("OPR") !== -1
  ) {
    browser = "browser--opera";
  } else if (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    navigator.userAgent.indexOf("Trident") !== -1
  ) {
    browser = "browser--ie";
  }

  document.body.classList.add(browser);
});

/* Hide empty blocks */
document.addEventListener("DOMContentLoaded", function () {
  const selectors = [".shopify-block", ".social-icons__wrapper"];

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);

    elements.forEach((el) => {
      if (!el.innerHTML.trim()) {
        el.style.display = "none";
      }
    });
  });
});

/* Get footer height */
/* Get header and footer heights */
document.addEventListener("DOMContentLoaded", function () {
  var footer = document.querySelector("footer");

  var footerHeight = footer.offsetHeight;

  document.documentElement.style.setProperty(
    "--footer-height",
    footerHeight + "px",
  );
});

// DIALOG
(function () {
  const trigger = document.getElementById("conditions");
  const dialog = document.getElementById("conditions-dialog");
  if (!trigger || !dialog) return;

  const closeBtn = dialog.querySelector(".dialog-close");

  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    dialog.showModal();
  });

  closeBtn?.addEventListener("click", () => dialog.close());

  // Close when clicking the backdrop (outside the dialog's content box)
  dialog.addEventListener("click", (e) => {
    const rect = dialog.getBoundingClientRect();
    const inDialog = e.clientY >= rect.top && e.clientY <= rect.bottom && v;
    e.clientX >= rect.left && e.clientX <= rect.right;
    if (!inDialog) dialog.close();
  });
})();

/* Hide empty blocks */
document.addEventListener("DOMContentLoaded", function () {
  const selectors = [".shopify-block", ".social-icons__wrapper"];

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);

    elements.forEach((el) => {
      if (!el.innerHTML.trim()) {
        el.style.display = "none";
      }
    });
  });
});

// FEATURED COLLECTIONS

(() => {
  const SELECTOR = ".featured-collection";
  const ACTIVE_CLASS = "is-active";
  const INACTIVE_CLASS = "is-inactive";

  const sections = Array.from(document.querySelectorAll(SELECTOR));
  if (!sections.length) return;

  // Build id -> element map for quick lookup
  const byId = new Map(sections.filter((el) => el.id).map((el) => [el.id, el]));

  function setActive(target) {
    if (!target) return;

    sections.forEach((el) => {
      const isActive = el === target;
      el.classList.toggle(ACTIVE_CLASS, isActive);
      el.classList.toggle(INACTIVE_CLASS, !isActive);
      el.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  // 1) Page load: first active by default
  // If URL already has a hash for a valid section, prefer that
  const initialHash = decodeURIComponent(window.location.hash || "").replace(
    "#",
    "",
  );
  setActive(byId.get(initialHash) || sections[0]);

  // 2) Click handler for links that target these sections
  document.addEventListener("click", (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const hash = decodeURIComponent(a.getAttribute("href"));
    const id = hash.slice(1);
    const target = byId.get(id);
    if (!target) return;

    // Optional: prevent default and smooth scroll ourselves
    // If you prefer native jump/scroll, remove preventDefault + scrollIntoView
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });

    // Update URL hash without forcing jump
    history.pushState(null, "", `#${encodeURIComponent(id)}`);

    // Immediately set active so blur updates as it scrolls
    setActive(target);
  });

  // 3) Keep active section in sync on scroll (IntersectionObserver)
  // We'll pick the section most "central" in view.
  let activeEl =
    document.querySelector(`${SELECTOR}.${ACTIVE_CLASS}`) || sections[0];

  const observer = new IntersectionObserver(
    (entries) => {
      // Consider only intersecting entries
      const visible = entries.filter((en) => en.isIntersecting);
      if (!visible.length) return;

      // Pick the one with highest intersection ratio
      visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio);
      const top = visible[0].target;

      if (top && top !== activeEl) {
        activeEl = top;
        setActive(activeEl);

        // Optional: keep URL hash updated while scrolling (comment out if you don't want this)
        if (activeEl.id) {
          history.replaceState(null, "", `#${encodeURIComponent(activeEl.id)}`);
        }
      }
    },
    {
      // Tune these to match the "active zone" you want
      // This makes "active" switch when the section is near mid viewport.
      root: null,
      threshold: [0.15, 0.5, 0.75],
      rootMargin: "-40% 0px -40% 0px",
    },
  );

  sections.forEach((el) => observer.observe(el));

  // 4) If user navigates with back/forward and hash changes, sync active
  window.addEventListener("hashchange", () => {
    const id = decodeURIComponent(window.location.hash || "").slice(1);
    const target = byId.get(id);
    if (target) setActive(target);
  });
})();

// SHOWS / LIGHTBOX
(() => {
  const triggers = {
    shows: document.getElementById("shows"),
    signup: document.getElementById("signup"),
  };

  const modals = {
    shows: document.getElementById("shows-lightbox"),
    signup: document.getElementById("signup-lightbox"),
  };

  let openKey = null;
  let lastActiveEl = null;

  // Basic a11y init
  Object.values(modals).forEach((modal) => {
    if (!modal) return;
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-hidden", "true");

    // Ensure content can receive focus
    const content = modal.querySelector(".lightbox-content");
    if (content && !content.hasAttribute("tabindex")) {
      content.setAttribute("tabindex", "-1");
    }
  });

  function openModal(key) {
    const modal = modals[key];
    if (!modal) return;

    // Close any currently open modal first
    if (openKey && openKey !== key) closeModal(openKey);

    openKey = key;
    lastActiveEl = document.activeElement;

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("modal-open");
    document.body.classList.add("modal-open");

    // Focus the content (or close button) after paint for smoother transitions
    requestAnimationFrame(() => {
      const content = modal.querySelector(".lightbox-content");
      const closeBtn = modal.querySelector(".close-btn");
      (content || closeBtn || modal).focus?.();
    });
  }

  function closeModal(key) {
    const modal = modals[key];
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    // Allow transition to finish before fully restoring scroll state if no other modal open
    const onDone = () => {
      modal.removeEventListener("transitionend", onDone);

      if (openKey === key) openKey = null;

      if (!openKey) {
        document.documentElement.classList.remove("modal-open");
        document.body.classList.remove("modal-open");
      }

      // Restore focus
      lastActiveEl?.focus?.();
      lastActiveEl = null;
    };

    // If transitions are disabled, transitionend may not fire; fallback:
    const prefersReduced = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)",
    )?.matches;
    if (prefersReduced) {
      onDone();
    } else {
      modal.addEventListener("transitionend", onDone, { once: true });
      // Safety fallback if transitionend doesn’t fire
      setTimeout(onDone, 300);
    }
  }

  // Trigger handlers
  triggers.shows?.addEventListener("click", (e) => {
    e.preventDefault();
    openModal("shows");
  });

  triggers.signup?.addEventListener("click", (e) => {
    e.preventDefault();
    openModal("signup");
  });

  // Close button + backdrop click (click outside content)
  Object.entries(modals).forEach(([key, modal]) => {
    if (!modal) return;

    modal
      .querySelector(".close-btn")
      ?.addEventListener("click", () => closeModal(key));

    modal.addEventListener("click", (e) => {
      const content = modal.querySelector(".lightbox-content");
      if (content && !content.contains(e.target)) {
        closeModal(key);
      }
    });
  });

  // ESC closes the currently open modal
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (openKey) closeModal(openKey);
  });
})();
